import { createColumnHelper } from '@tanstack/table-core';
import _isNil from 'lodash/isNil';
import React from 'react';
import Checkbox from '@Components/DomElements/Checkbox';
import SettingsTable, {
    SettingsTableViewState,
} from '@Components/Settings/components/SettingsTable/SettingsTable';
import { IUser } from '@Data/users/Interfaces';

interface IAddTeamMembersTableProps {
    selectedUserIds: string[];
    setSelectedUserIds: React.Dispatch<React.SetStateAction<string[]>>;
    users: IUser[];
    id: string;
}

const AddTeamMembersTable = (props: IAddTeamMembersTableProps) => {
    const { selectedUserIds, setSelectedUserIds, users, id } = props;

    const toggleUserSelection = (userId: string) => {
        const existingIndex = selectedUserIds.findIndex((id) => id === userId);
        const newUserIdArray = [...selectedUserIds];

        if (existingIndex > -1) {
            newUserIdArray.splice(existingIndex, 1);
        } else {
            newUserIdArray.push(userId);
        }

        setSelectedUserIds(newUserIdArray);
    };

    const columnHelper = createColumnHelper<IUser>();
    const columns = [
        columnHelper.accessor('email', {
            cell: (info) => info.getValue(),
            header: 'Member IKE ID',
        }),
        columnHelper.accessor('nickname', {
            cell: (info) => {
                const user = info.row.original;
                return user.given_name && user.family_name
                    ? `${user.given_name} ${user.family_name}`
                    : '-';
            },
            header: 'Name',
        }),
        columnHelper.accessor('action', {
            cell: (info) => {
                const userId = info.row.original.user_id;
                const selectedUserId = selectedUserIds.find((id) => {
                    return id === userId;
                });
                return (
                    <Checkbox
                        id={`${info.row.id}-checkbox`}
                        onClick={() => toggleUserSelection(userId)}
                        checked={!_isNil(selectedUserId)}
                        sx={{
                            color: '#000000',
                        }}
                    />
                );
            },
            header: '',
            enableSorting: false,
        }),
    ];

    return (
        <React.Fragment>
            <SettingsTable
                id={`${id}-table`}
                columns={columns}
                data={users}
                state={SettingsTableViewState.VIEW}
            />
        </React.Fragment>
    );
};

export default AddTeamMembersTable;
